const routes = {
  root: '/scheduled-cst/details',
}

export default routes
